import LandingLayout from "~/components/layouts/landing/index.vue"
import AuthLayout from "~/components/layouts/AuthLayout.vue";
export const landingRoutes:any[] =  [
  {
    path: "/",
    name: "LandingHome",
    component: () => import("~/pages/index.vue"),
    meta: { layout: LandingLayout, subject: 'Landing', action: 'read' },
    beforeEnter: (to, from, next) => {
      const isSaas = import.meta.env.VITE_IS_SAAS === 'true';
      if (isSaas) {
        next();
      } else {
        next({name : "/dashboard"});
      }
    }
  },
  {
    path: "/profile",
    name: "LandingUserProfile",
    component: () => import("~/pages/profile/index.vue"),
    meta: { layout: LandingLayout, subject: 'Landing', action: 'read' },

  },
  {
    path: "/try",
    name : "Try",
    component : () => import('~/pages/try/index.vue'),
    meta: { layout: LandingLayout, subject: 'Landing', action: 'read' },
  },
  {
    path : "/auth/sign-up",
    name : "SignUp",
    component : () => import('~/pages/auth/sign-up/index.vue'),
    meta: { layout: AuthLayout, subject: 'Auth', action: 'read' },
  },
  {
    path : "/auth/sign-in",
    name : "SignIn",
    component : () => import('~/pages/auth/sign-in/index.vue'),
    meta: { layout: AuthLayout, subject: 'Auth', action: 'read' },
  },
];
